interface CalculatorCardProps {
  children: React.ReactNode;
  className?: string;
}

export function CalculatorCard({ children, className = '' }: CalculatorCardProps) {
  return (
    <div className={`bg-white rounded-xl border-2 border-gray-200 p-6 shadow-sm ${className}`}>
      {children}
    </div>
  );
}

interface CalculatorSectionProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  icon?: React.ReactNode;
}

export function CalculatorSection({ title, description, children, icon }: CalculatorSectionProps) {
  return (
    <div className="mb-8">
      <div className="flex items-center gap-3 mb-4">
        {icon && <div className="text-2xl">{icon}</div>}
        <div>
          <h3 className="text-xl font-bold text-gray-900">{title}</h3>
          {description && <p className="text-sm text-gray-600 mt-1">{description}</p>}
        </div>
      </div>
      {children}
    </div>
  );
}
